import React from 'react';
import { Row, Col, Tooltip } from 'antd';
import { I18n } from '@aws-amplify/core';
import { InfoCircleOutlined } from '@ant-design/icons';

import { useAutoCalculate } from './hooks';
import { BodyPostureFormItem, AdditionalFactorsFormItem } from './Fields';
import { SectionTitle, SectionDescription } from '@/components/views/Report/KimLhc/Components/Shared/styles';
import { PartialResultBadge, VideoDrawerHeader, ResultBadge } from '@/components/views/Report/KimLhc/Components/Shared';
import { FieldNamesEnum } from '@/components/views/Report/KimLhc/types';
import { POSTURE_BODY_DESCRIPTION, POSTURE_BODY_TOOLTIP } from '@/components/views/Report/KimLhc/Constants';

import * as S from './styles';

export function Posture(): JSX.Element {
	const POSTURE_GROUP = FieldNamesEnum.POSTURE;

	const { bodyPostureScore, additionalFactorsScore } = useAutoCalculate();

	return (
		<Row>
			<Col span={24}>
				<Row gutter={[0, 40]}>
					<Col span={24}>
						<VideoDrawerHeader title={I18n.get('Posture')} />
					</Col>
					<Col span={24}>
						<Row gutter={[0, 48]}>
							<Col span={24}>
								<Row gutter={[0, 24]}>
									<Col span={24}>
										<Row gutter={16} align="middle" justify="space-between">
											<Col flex="1">
												<SectionTitle level={5}>
													{I18n.get('Body posture')}
													<S.RequiredAsterisk>*</S.RequiredAsterisk>
												</SectionTitle>
												<SectionDescription>
													{I18n.get(POSTURE_BODY_DESCRIPTION)}{' '}
													<Tooltip title={I18n.get(POSTURE_BODY_TOOLTIP)}>
														<S.InfoIconWrapper>
															<InfoCircleOutlined />
														</S.InfoIconWrapper>
													</Tooltip>
												</SectionDescription>
											</Col>
											<Col>
												<ResultBadge value={bodyPostureScore} />
											</Col>
										</Row>
									</Col>
									<Col span={24}>
										<BodyPostureFormItem fieldName={[POSTURE_GROUP, 'body_posture']} />
									</Col>
								</Row>
							</Col>
							<Col span={24}>
								<Row gutter={[0, 16]}>
									<Col span={24}>
										<Row gutter={16} align="middle" justify="space-between">
											<Col flex="1">
												<SectionTitle level={5}>{I18n.get('Additional factors')}</SectionTitle>
											</Col>
											<Col>
												<ResultBadge value={additionalFactorsScore} />
											</Col>
										</Row>
									</Col>
									<Col span={24}>
										<AdditionalFactorsFormItem fieldNamePrefix={POSTURE_GROUP} />
									</Col>
								</Row>
							</Col>
							<PartialResultBadge />
						</Row>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
